<template>
  <div
    class="uk-width-1-1 uk-margin-top uk-flex block block--faint block--button block--expand block--buttonPrimary"
    @click="$emit('click')"
  >
    <span class="uk-icon-pencil uk-margin-small-right" /> {{ registerButtonText }}
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class RegisterButton extends Vue {
  @Prop() create!: boolean;
  @Prop({default: ''}) text!: string;

  get registerButtonClasses(): string {
    const cls = ['uk-width-8-10'];
    if (!this.create) {
      // cls.push('uk-width-medium-1-2');
      return "uk-width-1-1 uk-width-medium-1-2 uk-container-center";
    }

    return "uk-width-1-2";
  }

  get registerButtonText(): string {
    if (this.text) {
      return this.text;
    }
    return this.create ? <string>this.$t('events.add_new_entry') : <string>this.$t('events.add_another_entry');
  }

}
</script>

<style scoped>

</style>
